/* 刮卡弹窗：固定分组、揭晓后领取计时及页面/抽屉互斥；不发送数据、不提交表单。 */
(function () {
  'use strict';
  if (window.ScratchPopupExperience) return;
  var key = 'trlab-scratch-form-v1', ttl = 30 * 86400000;
  function assign(mode, preview) {
    if (mode !== 'ab' || preview) return { variant: mode === 'b' ? 'b' : 'a', experiment: '' };
    try {
      var saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (!saved || !/^[ab]$/.test(saved.variant) || !Number.isFinite(saved.expires) ||
          saved.expires <= Date.now() || saved.expires > Date.now() + ttl) {
        var random = new Uint32Array(1);
        crypto.getRandomValues(random);
        saved = { variant: random[0] < 2147483648 ? 'a' : 'b', expires: Date.now() + ttl };
        localStorage.setItem(key, JSON.stringify(saved));
        if (localStorage.getItem(key) !== JSON.stringify(saved)) throw new Error('Storage unavailable');
      }
      return { variant: saved.variant, experiment: 'scratch-form-v1:' + saved.variant };
    } catch (_) {
      // 无法固定分组的浏览器使用 A，不混入实验样本。
      return { variant: 'a', experiment: '' };
    }
  }
  function idle(popup, enter) {
    var seconds = Number(popup.dataset.revealDelay);
    var delay = (Number.isFinite(seconds) && seconds >= 1 && seconds <= 30 ? seconds : 5) * 1000;
    var timer, started = 0, remaining = delay, armed = false;
    function pause() {
      clearTimeout(timer);
      if (started) remaining = Math.max(0, remaining - (performance.now() - started));
      started = 0;
    }
    function cancel() { pause(); armed = false; }
    function resume() {
      if (!armed || document.hidden || popup.hidden || !popup.isConnected) return;
      started = performance.now();
      timer = setTimeout(function () {
        cancel();
        if (!popup.hidden && popup.isConnected && popup.classList.contains('is-open')) enter();
      }, remaining);
    }
    function visibility() { if (document.hidden) pause(); else resume(); }
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('pagehide', cancel);
    return {
      arm: function () { cancel(); remaining = delay; armed = true; resume(); },
      cancel: cancel,
      destroy: function () {
        cancel();
        document.removeEventListener('visibilitychange', visibility);
        window.removeEventListener('pagehide', cancel);
      }
    };
  }
  function blockedPage(pageType, pathname) {
    if (/^(cart|checkout|thank_you|order_status)$/.test(pageType || '')) return true;
    var parts = (pathname || '').toLowerCase().split('/').filter(Boolean);
    if (/^[a-z]{2}(?:-[a-z]{2})?$/.test(parts[0] || '')) parts.shift();
    return /^(cart|checkout|checkouts|wishlist)$/.test(parts[0] || '') ||
      (parts[0] === 'pages' && /^(wishlist|wish-list|thank-you|thankyou|thank_you)$/.test(parts[1] || '')) ||
      parts.some(function (part) { return /^(thank_you|thank-you|thankyou|order_status)$/.test(part); });
  }
  function watchContext(popup, changed) {
    function blocked() {
      return blockedPage(popup.dataset.pageType, location.pathname) || Boolean(document.querySelector(
        '#CartDrawer.drawer--is-open, #CartDrawer[aria-hidden="false"], ' +
        '#WishlistDrawer.is-open, #WishlistDrawer[aria-hidden="false"], body.wishlist-drawer-open'
      ));
    }
    var previous = blocked();
    function check() { var next = blocked(); if (next !== previous) { previous = next; changed(next); } }
    // 只读取既有抽屉状态；不更改购物车/心愿单事件总线，兼容动态重建节点。
    var observer = new MutationObserver(check);
    observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'hidden'] });
    window.addEventListener('popstate', check);
    window.addEventListener('hashchange', check);
    return { blocked: blocked, destroy: function () {
      observer.disconnect(); window.removeEventListener('popstate', check); window.removeEventListener('hashchange', check);
    } };
  }
  window.ScratchPopupExperience = { assign: assign, idle: idle, watchContext: watchContext, blockedPage: blockedPage };
})();
